/**
 * 🌫️ useMistyMap — hook that pings the backend to mark an area as
 * visited the moment a page mounts. Idempotent — only the first call
 * per area actually flips the fog bit.
 *
 * Usage:
 *   function FarmPage() {
 *     useMistyMap("farm");          // pings POST /api/misty-map/visit/farm
 *     return <div>...</div>;
 *   }
 *
 * Silently no-ops for unauthenticated users (401 → swallow). Safe to
 * sprinkle across every page without conditional checks.
 */
import { useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function useMistyMap(areaId) {
  useEffect(() => {
    if (!areaId) return;
    // Fire-and-forget — newly_unlocked toast handled by the caller if
    // they want to celebrate the moment.
    axios
      .post(`${API}/misty-map/visit/${areaId}`)
      .catch(() => { /* unauth or offline — silently swallow */ });
  }, [areaId]);
}
